<template>
  <Layout>
    <PageHeader :title="title" :items="breadcrumbItems" hasBreadcrumb hasBackButton />

    <div class="card">
      <div class="card-body row">
        <template v-for="menu in menuList">
          <MenuCard
            v-if="hasAccess(menu.scopes)"
            :key="menu.key"
            hasHoverEffect
            :title="menu.title"
            :description="menu.desc"
            @click="$router.push({ name: menu.pathName })"
          />
        </template>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import { mapGetters } from 'vuex'

import Layout from '@/router/layouts/main'
import PageHeader from '@/components/page-header-v2'
import MenuCard from './components/MenuCard'

import menuList from './lib/menu-list'

export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    MenuCard,
  },
  data() {
    return {
      menuList,
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    title() {
      return 'Kolom Custom'
    },
    breadcrumbItems() {
      return [
        {
          text: this.$t('setting.list.development.setting'),
          to: '/setting',
        },
        {
          text: 'Kolom Custom',
        },
      ]
    },
  },
}
</script>
